export const featuredData = {
  "Page Builder": [
    {
      title: "Page Builder",
      display_name:"Web Page Builder",
      desc: "Create, edit, and build custom web pages with simple text or voice prompts.",
      by: "varnz.ai",
      icon: "🌐",
    },
  ],
  "Card Maker": [
    {
      title: "Card Maker",
      display_name:"Greeting Card Maker",
      desc: "Create personalized greeting, wedding, anniversary, and invitation cards effortlessly.",
      by: "varnz.ai",
      icon: "💌",
    },
  ],
  // Document: [
  //   {
  //     title: "Business Plan",
  //     desc: "Outline your company’s mission, goals, and growth strategy.",
  //     by: "planbuilder.ai",
  //     icon: "📊",
  //   },
  //   {
  //     title: "Marketing Plan",
  //     desc: "Define marketing goals, target audience, and campaign strategies.",
  //     by: "marketgen.io",
  //     icon: "💼",
  //   },
  //   {
  //     title: "Content Strategy Document",
  //     desc: "Plan content themes, formats, and publishing schedule for maximum reach.",
  //     by: "contentpilot.ai",
  //     icon: "📝",
  //   },
  //   {
  //     title: "Go-to-Market Strategy",
  //     desc: "Craft a roadmap for launching products and reaching target customers.",
  //     by: "launchpath.io",
  //     icon: "🚀",
  //   },
  //   {
  //     title: "SWOT Analysis",
  //     desc: "Identify strengths, weaknesses, opportunities, and threats for your business.",
  //     by: "strategix.ai",
  //     icon: "📈",
  //   },
  //   {
  //     title: "Product Roadmap",
  //     desc: "Visualize your product’s vision, milestones, and release schedule.",
  //     by: "roadmapper.io",
  //     icon: "🗺️",
  //   },
  //   {
  //     title: "OKRs / KPIs Document",
  //     desc: "Set measurable goals and track team performance with clear KPIs.",
  //     by: "metricmind.ai",
  //     icon: "🎯",
  //   },
  //   {
  //     title: "Executive Summary",
  //     desc: "Summarize your business plan’s key points for stakeholders and investors.",
  //     by: "briefly.io",
  //     icon: "📃",
  //   },
  // ],
  "Agents": [],
  // Marketing: [
  //   {
  //     title: "Instagram Graphic",
  //     desc: "Create eye-catching Instagram posts and stories",
  //     by: "instaboost.io",
  //     icon: "📸",
  //   },
  //   {
  //     title: "LinkedIn Graphic",
  //     desc: "Design professional LinkedIn banners and posts",
  //     by: "linkhelper.ai",
  //     icon: "💼",
  //   },
  //   {
  //     title: "Twitter Graphic",
  //     desc: "Generate visually engaging Twitter content",
  //     by: "twtrend.com",
  //     icon: "🐦",
  //   },
  //   {
  //     title: "Video Script Generator",
  //     desc: "Create compelling scripts for marketing videos",
  //     by: "scriptgen.io",
  //     icon: "🎬",
  //   },
  // ],
  // "Social Media Tool": [
  //   {
  //     title: "Instagram Hashtag Generator",
  //     desc: "Find trending hashtags to boost engagement",
  //     by: "hashtagpro.ai",
  //     icon: "🏷️",
  //   },
  //   {
  //     title: "Facebook Ad Creator",
  //     desc: "Easily design and launch Facebook ads",
  //     by: "adcreator.ai",
  //     icon: "📢",
  //   },
  //   {
  //     title: "Instagram Caption Generator",
  //     desc: "Generate catchy captions for posts",
  //     by: "captionbot.io",
  //     icon: "✍️",
  //   },
  //   {
  //     title: "YouTube Video Description Optimizer",
  //     desc: "Optimize YouTube descriptions for SEO and engagement",
  //     by: "videoseo.ai",
  //     icon: "🎥",
  //   },
  // ],
  // "Popular Tools": [
  //   {
  //     title: "Essay Writer",
  //     desc: "Craft well-structured essays on any topic with AI assistance",
  //     by: "essaygenius.ai",
  //     icon: "✍️",
  //   },
  //   {
  //     title: "Song Lyrics Generator",
  //     desc: "Generate creative song lyrics in any style",
  //     by: "lyricsgen.ai",
  //     icon: "🎵",
  //   },
  //   {
  //     title: "Story Generator",
  //     desc: "Generate engaging short stories and narratives effortlessly",
  //     by: "storyforge.ai",
  //     icon: "📚",
  //   },
  //   {
  //     title: "Research Paper Writer",
  //     desc: "Assist in writing structured academic papers",
  //     by: "researchhelper.ai",
  //     icon: "📄",
  //   },
  //   {
  //     title: "Content Rewriter",
  //     desc: "Rephrase or rewrite existing content to make it unique and polished",
  //     by: "contentrevamp.io",
  //     icon: "🔄",
  //   },
  //   {
  //     title: "Slogan Generator",
  //     desc: "Create catchy slogans for brands and products",
  //     by: "slogangen.io",
  //     icon: "💡",
  //   },
  //   {
  //     title: "Ad Copy Generator",
  //     desc: "Create compelling ad copy for social media, Google Ads, and more",
  //     by: "adcraft.ai",
  //     icon: "📢",
  //   },
  //   {
  //     title: "Internship Report Generator",
  //     desc: "Automatically generate internship reports with summaries",
  //     by: "reportgen.ai",
  //     icon: "📝",
  //   },
  //   {
  //     title: "Experience Generator",
  //     desc: "Create professional experience descriptions for resumes",
  //     by: "resumebuilder.ai",
  //     icon: "🖊️",
  //   },
  // ],
};

export const menuOptions = [
  { title: "Page Builder" },
  { title: "Card Maker" },
  // {
  //   title: "Document",
  //   subItems: [
  //     "Business Plan",
  //     "Marketing Plan",
  //     "Content Strategy Document",
  //     "Go-to-Market Strategy",
  //     "SWOT Analysis",
  //     "Product Roadmap",
  //     "OKRs / KPIs Document",
  //     "Executive Summary",
  //   ],
  // },
  // {
  //   title: "Marketing",
  //   subItems: [
  //     "Instagram Graphic",
  //     "LinkedIn Graphic",
  //     "Twitter Graphic",
  //     "Video Script Generator",
  //   ],
  // },
  // {
  //   title: "Social Media Tool",
  //   subItems: [
  //     "Instagram Hashtag Generator",
  //     "Facebook Ad Creator",
  //     "Instagram Caption Generator",
  //     "YouTube Video Description Optimizer",
  //   ],
  // },
  // {
  //   title: "Popular Tools",
  //   subItems: [
  //     "Essay Writer",
  //     "Song Lyrics Generator",
  //     "Story Generator",
  //     "Research Paper Writer",
  //     "Content Rewriter",
  //     "Slogan Generator",
  //     "Ad Copy Generator",
  //     "Internship Report Generator",
  //     "Experience Generator",
  //   ],
  // },
];

const baseCards = [
  {
    id: "pageBuilder",
    title: "Page Builder",
    description:
      "Create, edit, and build custom web pages with simple text or voice prompts.",
    shortDesc: "Build stunning pages easily.",
    iconColor: "fill-black/70 dark:fill-white/70",
  },
  {
    id: "cardMaker",
    title: "Card Maker",
    description:
      "Create personalized greeting, wedding, anniversary, and invitation cards effortlessly.",
    shortDesc: "Design beautiful cards instantly.",
    iconColor: "fill-black/70 dark:fill-white/70",
  },
];

export const homeCards = {
  Document: [
    {
      title: "Business Plan",
      desc: "Outline your company’s mission, goals, and growth strategy.",
      by: "planbuilder.ai",
      icon: "📊",
    },
    {
      title: "Marketing Plan",
      desc: "Define marketing goals, target audience, and campaign strategies.",
      by: "marketgen.io",
      icon: "💼",
    },
    {
      title: "Content Strategy Document",
      desc: "Plan content themes, formats, and publishing schedule for maximum reach.",
      by: "contentpilot.ai",
      icon: "📝",
    },
    {
      title: "Go-to-Market Strategy",
      desc: "Craft a roadmap for launching products and reaching target customers.",
      by: "launchpath.io",
      icon: "🚀",
    },
    {
      title: "SWOT Analysis",
      desc: "Identify strengths, weaknesses, opportunities, and threats for your business.",
      by: "strategix.ai",
      icon: "📈",
    },
    {
      title: "Product Roadmap",
      desc: "Visualize your product’s vision, milestones, and release schedule.",
      by: "roadmapper.io",
      icon: "🗺️",
    },
    {
      title: "OKRs / KPIs Document",
      desc: "Set measurable goals and track team performance with clear KPIs.",
      by: "metricmind.ai",
      icon: "🎯",
    },
    {
      title: "Executive Summary",
      desc: "Summarize your business plan’s key points for stakeholders and investors.",
      by: "briefly.io",
      icon: "📃",
    },
  ],
};

// ✅ Convert featuredData (object) into a flat array of items
const generatedCards = Object.values(homeCards)
  .flat()
  .map((item) => ({
    id: item.title.toLowerCase().replace(/\s+/g, "-"),
    title: item.title,
    description: item.desc,
    shortDesc: `Created by ${item.by}`,
    iconColor: "fill-black/70 dark:fill-white/70",
  }));

// ✅ Combined export for use anywhere
export const cards = [...baseCards, ...generatedCards];

export const isDocumentType = (chatType) => {
  return [
    "business_plan",
    "marketing_plan",
    "content_strategy_document",
    "go_to_market_strategy",
    "swot_analysis",
    "product_roadmap",
    "okrs_kpis_document",
    "executive_summary",
  ].includes(chatType);
};

export const isActiveDocument = (type) => {
  return [
    "Business Plan",
    "Marketing Plan",
    "Content Strategy Document",
    "Go-to-Market Strategy",
    "SWOT Analysis",
    "Product Roadmap",
    "OKRs / KPIs Document",
    "Executive Summary",
  ].includes(type);
};

export const modelOption = [
  { id: "gpt-4o-mini", label: "GPT-4o Mini" },
   { id: "gpt-4o", label: "GPT-4o" },
];
